// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import * as jwt_decode from 'jwt-decode';

export enum AuthActionTypes {
  TRIGGER_LOGIN = '[Auth] TRIGGER_LOGIN',
  TRIGGER_LOGIN_REFRESH = '[Auth] TRIGGER_LOGIN_REFRESH',
  FAIL_LOGIN_REFRESH = '[Auth] FAIL_LOGIN_REFRESH',
  LOGIN = '[Auth] LOGIN',
  LOGOUT = '[Auth] LOGOUT'
}

export class Token {
  constructor(public readonly accessToken: string, public readonly idToken: string, public readonly expiresAt: Date) {}
}

export class OIDCUser {
  givenName: string;
  familyName: string;
  timezone: string;
  email: string;
  username: string;
  sub: string;

  constructor(token: Token) {
    const idToken = jwt_decode(token.idToken) as any;
    this.givenName = idToken.given_name || '';
    this.familyName = idToken.family_name || '';
    this.timezone = idToken.zoneinfo || '';
    this.email = idToken.email || '';
    this.sub = idToken.sub || '';
    this.username = this.hasPassword ? idToken.nickname : '';
  }

  public get hasPassword() {
    return this.provider === 'auth0';
  }

  private get provider() {
    const [provider] = this.sub.split('|');
    return provider;
  }
}

export class TriggerLoginAction implements Action {
  readonly type = AuthActionTypes.TRIGGER_LOGIN;
  readonly payload: {
    redirectPath: any[];
  };

  /**
   * Trigger's an Auth0 login, by redirecting to an external website.
   * @param redirectPath The redirect path using angular's Router path format, eg [ '/some-path', {'some-param': 1} ]
   */
  constructor(redirectPath: any[]) {
    this.payload = { redirectPath };
  }
}

export class TriggerLoginRefreshAction implements Action {
  readonly type = AuthActionTypes.TRIGGER_LOGIN_REFRESH;
}

export class LoginAction implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public readonly payload: Token) {}
}

export class LogoutAction implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export class FailLoginRefreshAction implements Action {
  readonly type = AuthActionTypes.FAIL_LOGIN_REFRESH;
}

export type AuthActionsUnion =
  | TriggerLoginAction
  | LoginAction
  | TriggerLoginRefreshAction
  | LogoutAction
  | FailLoginRefreshAction;



// WEBPACK FOOTER //
// ./src/app/core/state/auth.actions.ts